import { useCallback } from 'react';

import { toaster } from '../ui/toaster';

export const useSnack = () => {
  const successMessage = useCallback((message: string) => {
    toaster.success({
      description: message,
    });
  }, []);
  const errorMessage = useCallback(
    (message: string) =>
      toaster.error({
        description: message,
      }),
    [],
  );

  const warnMessage = useCallback(
    (message: string) =>
      toaster.create({
        description: message,
        type: 'warning',
      }),
    [],
  );

  const infoMessage = useCallback(
    (message: string) =>
      toaster.create({
        description: message,
        type: 'info',
      }),
    [],
  );

  return {
    successMessage,
    errorMessage,
    warnMessage,
    infoMessage,
  };
};
